















import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { defineComponent } from '@vue/composition-api';
import type Vue from 'vue';

interface RollingListComponent extends Vue {
  listData: {
    text: string;
    link?: string;
  }[];
  emptyText: string;
  itemHeight: number;
  activeIndex: number;
  handleClick: () => void;
}

export default defineComponent({
  name: 'RollingList',
  props: {
    /** 列表数据 */
    listData: {
      type: Array,
      required: true,
    },
    /**
     * 当列表为空时展示的文本
     * 不传时，不展示整个区块
     */
    emptyText: {
      type: String,
    },
    /**
     * 每一行的固定高度，可不传，不传时自动计算高度，对外部css要求较高
     */
    itemHeight: {
      type: Number,
    },
  },
  computed: {
    isListEmpty(this: RollingListComponent) {
      return !this.listData?.length;
    },
    swiperOptions(this: RollingListComponent) {
      const options = {
        direction: 'vertical',
        speed: 500,
        loop: true,
        allowTouchMove: false,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
        },
        autoHeight: true,
        on: {
          slideChange: () => {
            // @ts-ignore
            const index = this.$refs.mySwiper?.realIndex as number;
            this.activeIndex = index;
          },
        },
      };
      if (this.itemHeight) {
        // @ts-ignore
        options.height = this.itemHeight;
      }
      return options;
    },
  },
  mounted(this: RollingListComponent) {
    this.activeIndex = 0;
  },
  methods: {
    handleClick(this: RollingListComponent) {
      const index = this.activeIndex;
      const activeItem = this.listData[index];
      this.$emit('click', index, activeItem);
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
});
